import React, { useEffect, useState } from "react";
import style from "./Success.module.scss";
import SuccessLoader from "./SuccessLoader";

function SuccessComponent({
  onclose,
  name,
  primaryHeading,
  textprimary,
  textprimary1,
  msgContent,
  msgContent1,
  boldContent,
  autoClose = false,
  autoCloseTime = 3000,
}) {
  const [progress, setProgress] = useState(0);

  // ✅ Auto close when progress complete
  useEffect(() => {
    if (autoClose && progress === 101) {
      const timer = setTimeout(() => {
        onclose();
      }, autoCloseTime);

      return () => clearTimeout(timer);
    }
  }, [autoClose, autoCloseTime, onclose, progress]);

  return (
    <div className={style.successContainer}>
      {/* HEADER */}
      {!primaryHeading ? (
        <div className={style.header}>
          <div>
            <span className={style.title}>{name}</span>
          </div>

          {/* <div>
            <img
              src={cancel}
              alt="close"
              onClick={onclose}
              style={{ cursor: "pointer" }}
            />
          </div> */}
        </div>
      ) : (
        <div className={`text-center ${style.textprimary}`}>
          {progress === 101 ? textprimary1 : textprimary}
        </div>
      )}

      {/* BODY */}
     <div className={style.successContainer}>
  <div className={style.successboxModel}>
    <div className={style.uploadingbox}>
      
      <SuccessLoader onProgress={(val) => setProgress(val)} />

      <span className={style.msgContent}>
        {progress === 101 ? msgContent1 : msgContent}
      </span>

      <b>{boldContent}</b>

    </div>
  </div>
</div>
    </div>
  );
}

export default SuccessComponent;
